import React from 'react';
import { XAxisProps, YAxisProps } from 'recharts';

export const CHART_SURFACE = '#212936'; // widget-bg
export const GRID_STROKE = '#2f3745';
const AXIS_STROKE = '#3a4152';
export const MUTED_INK = '#898781';

export function formatCompact(value: number): string {
  if (value >= 1_000_000) return `${(value / 1_000_000).toFixed(1)}M`;
  if (value >= 1_000) return `${(value / 1_000).toFixed(1)}k`;
  return String(value);
}

const AXIS_TICK = { fill: MUTED_INK, fontSize: 11 };
export const X_AXIS_PROPS: XAxisProps = {
  tick: AXIS_TICK,
  axisLine: { stroke: AXIS_STROKE },
  tickLine: false,
  interval: 'equidistantPreserveStart',
  minTickGap: 12,
};
export const Y_AXIS_PROPS: YAxisProps = { tick: AXIS_TICK, axisLine: false, tickLine: false, width: 48, tickFormatter: formatCompact };

export function ChartTooltip({ active, payload, label }: any) {
  if (!active || !payload) return null;
  // Reverse the rows to show the top of the stack first.
  const rows = payload.filter((p: any) => p.value > 0).reverse();
  if (rows.length === 0) return null;
  const total = payload.reduce((sum: number, p: any) => sum + (p.value || 0), 0);
  return (
    <div className="bg-body-bg border border-gray-700 rounded-md px-3 py-2 text-xs shadow-lg">
      <div className="text-heading font-medium mb-1">{label}</div>
      {rows.map((p: any) => (
        <div key={p.dataKey} className="flex items-center gap-2 text-body-color">
          <span className="w-2 h-2 rounded-full" style={{ backgroundColor: p.color ?? p.fill }} />
          <span>{p.name}</span>
          <span className="ml-auto pl-4 font-mono">{p.value.toLocaleString()}</span>
        </div>
      ))}
      {rows.length > 1 && (
        <div className="flex items-center gap-2 text-heading border-t border-gray-700 mt-1 pt-1">
          <span>Total</span>
          <span className="ml-auto pl-4 font-mono">{total.toLocaleString()}</span>
        </div>
      )}
    </div>
  );
}

export const toggleClass = (on: boolean) =>
  `px-3 py-1.5 text-sm rounded-md transition-colors ${
    on ? 'bg-primary/20 text-primary' : 'text-secondary hover:text-body-color'
  }`;

